import { getStartDateForLastDateTimeRange } from '@modules/common/utils/getStartDateForLastDateTimeRange';
import { Dayjs } from 'dayjs';
import { TimeRange } from 'v2/core/entities';

export const isTimeBeforeDateRange = (
  start: Dayjs,
  dateRange: TimeRange,
  timezone: string,
): boolean => {
  switch (dateRange.type) {
    case 'since':
    case 'absolute':
      return start.isBefore(dateRange.startAfter, 'date');
    case 'last':
      const startDateForLast = getStartDateForLastDateTimeRange(
        dateRange,
        timezone,
      );
      return start.isBefore(startDateForLast, 'date');
  }
};
